<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <span class="md:flex hidden items-right">
            <span>Feito com </span>
            <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2 mr-2"/>
            <span>por <a href="https://efice.co" target="_blank">efice.co</a></span>
        </span>
    </footer>
</template>

<script>
    export default {
        name: "the-footer",
        props: {
            classes: {
                type: String,
            },
        },
    }
</script>
